<template>
  <index-panel
    collection="indexes"
    :doc="$route.params.name"
  />
</template>

<script>
import IndexPanel from './IndexPanel';

export default {
  components: {
    IndexPanel,
  },
};
</script>
